import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';

import * as auth from '../app/modules/Auth/_redux/authRedux';
import * as moderation from '../app/modules/Moderation/_redux/moderationRedux';
import * as dashboard from '../app/modules/Dashboard/_redux';
import * as users from '../app/modules/Users/_redux';
import * as posts from '../app/modules/Posts/_redux';
import * as ambassadors from '../app/modules/Ambassador/_redux';
import * as feed from '../app/modules/Feed/_redux';
import * as challenges from '../app/modules/Challenges/_redux';
import * as social from '../app/modules/SocialMedia/_redux';
import * as stories from '../app/modules/Story/_redux';
import * as merchants from './merchants';

export const rootReducer = combineReducers({
	auth: auth.reducer,
	moderation: moderation.reducer,
	dashboard: dashboard.reducer,
	merchants: merchants.reducer,
	users: users.reducer,
	posts: posts.reducer,
	feed: feed.reducer,
	challenges: challenges.reducer,
	social: social.reducer,
	stories: stories.reducer,
	ambassadors: ambassadors.reducer,
});

export function* rootSaga() {
	yield all([
		dashboard.saga(),
		moderation.saga(),
		merchants.saga(),
		users.saga(),
		posts.saga(),
		ambassadors.saga(),
	]);
}

export type RootState = ReturnType<typeof rootReducer>